import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import UITourBackButton from 'ui-shepherd-react/button/UITourBackButton';
import OnboardingTourFinishButton from './OnboardingTourFinishButton';
import { BACK, FINISH, NEXT } from '../constants/TourActions';
import SentryManager from '../manager/SentryManager';
import { useTourContext } from '../hooks/tour'; // Omit size as React.AllHTMLAttributes has size?: number, but it can be string in UIButton

export default function OnboardingTourButton(_ref) {
  let {
    action,
    beforeButtonEnabled
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["action", "beforeButtonEnabled"]);

  const [disabled, setDisabled] = useState(() => typeof beforeButtonEnabled === 'function');
  const {
    tour
  } = useTourContext();
  const stepId = tour.getStep() || 'unknown';
  const tourId = tour.getTour() || 'unknown';
  useEffect(() => {
    if (typeof beforeButtonEnabled === 'function') {
      beforeButtonEnabled().then(() => setDisabled(false)).catch(error => SentryManager.reportOnboardingTourButtonButtonError(error, tourId, stepId));
    }
  }, [beforeButtonEnabled, tourId, stepId]);

  switch (action) {
    case BACK:
      return /*#__PURE__*/_jsx(UITourBackButton, Object.assign({
        disabled: disabled
      }, props));

    case NEXT:
      return /*#__PURE__*/_jsx(UITourNextButton, Object.assign({
        disabled: disabled
      }, props));

    case FINISH:
      return /*#__PURE__*/_jsx(OnboardingTourFinishButton, Object.assign({
        disabled: disabled
      }, props));

    default:
      return /*#__PURE__*/_jsx(UIButton, Object.assign({
        disabled: disabled
      }, props));
  }
}